import { render, staticRenderFns } from "./TranslatorPaymentsForm.vue?vue&type=template&id=5745a08d&"
import script from "./TranslatorPaymentsForm.vue?vue&type=script&lang=js&"
export * from "./TranslatorPaymentsForm.vue?vue&type=script&lang=js&"
import style0 from "./TranslatorPaymentsForm.vue?vue&type=style&index=0&id=5745a08d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports